import React from "react";
import { useTranslation } from "react-i18next";
import "./AboutUs.css";

const AboutUs = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === "ar";

  return (
    <main
      className={`page container about-page ${isRTL ? "rtl" : "ltr"}`}
      dir={isRTL ? "rtl" : "ltr"}
    >
      <section className="page-section">

        {/* Title */}
        <div className="section-title">
          <h3>{t("About Title", "About Us")}</h3>
          <div className="muted">
            {t("About Subtitle", "Our mission & story")}
          </div>
        </div>

        {/* Layout */}
        <div className="about-layout">

          {/* LEFT */}
          <div className="about-text">
            <p className="muted">
              {t(
                "About Main Paragraph",
                "Infinite Beirut International is a modern classifieds platform connecting buyers and sellers across Arab countries. Our vision is to create a trusted marketplace with localized categories and easy search by country."
              )}
            </p>

            <h4 className="about-vision-title">
              {t("About Vision Title", "Vision")}
            </h4>
            <p className="muted">
              {t(
                "About Vision Text",
                "To be the leading classifieds hub for the Arab world — reliable, fast and secure."
              )}
            </p>
          </div>

          {/* RIGHT */}
          <aside className="about-card">
            <h4 className="about-contact-title">
              {t("About Contact Title", "Contact")}
            </h4>
            <p className="muted">
              {t("About Contact Text", "info@infinitelb.com")}
            </p>
          </aside>

        </div>
      </section>
    </main>
  );
};

export default AboutUs;
